












































import _ from 'lodash';
import Popover from '@/components/common/Popover.vue';
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import InputText from '@/components/common/form/InputText.vue';
import FormInput from '@/components/common/form/FormInput.vue';
import Errors from '@/components/common/form/Errors.vue';
import i18n from '@/i18n';
const { mapState, mapGetters, mapMutations } = createNamespacedHelpers('grievanceForm');

export default Vue.extend({
    components: { InputText, FormInput, Popover, Errors },
    computed: {
        address(): string {
            return _.compact([
                this.addressLine1,
                this.addressLine2,
                this.neighborhood,
                this.sublocality,
                this.city,
                this.state,
                this.country,
                this.postalCode,
                this.sublocality2,
                this.arealevel2,
            ]).join(', ');
        },
        addressFields(): { name: string; value: string }[] {
            return [
                {
                    name: 'addressLine1',
                    value: this.addressLine1,
                },
                {
                    name: 'addressLine2',
                    value: this.addressLine2,
                },
                {
                    name: 'neighborhood',
                    value: this.neighborhood,
                },
                {
                    name: 'sublocality2',
                    value: this.sublocality2,
                },
                {
                    name: 'sublocality',
                    value: this.sublocality,
                },
                {
                    name: 'city',
                    value: this.city,
                },
                {
                    name: 'arealevel2',
                    value: this.arealevel2,
                },
                {
                    name: 'state',
                    value: this.state,
                },
                {
                    name: 'country',
                    value: this.country,
                },
                {
                    name: 'postalCode',
                    value: this.postalCode,
                },
            ];
        },

        addressFieldsIsRequired(): boolean {
            return _.some(this.visibleAddressFields, visibleAddressField =>
                this.isFieldRequired(visibleAddressField.name),
            );
        },
        addressFieldsHasError(): boolean {
            return _.some(this.visibleAddressFields, visibleAddressField =>
                this.getFieldErrors(visibleAddressField.name),
            );
        },
        getAddressError(): string[] {
            return this.addressFieldsHasError ? ([i18n.t('required')] as string[]) : [''];
        },
        visibleAddressFields(): { name: string; value: string }[] {
            return this.addressFields.filter(({ name }) => this.isFieldVisible(name));
        },
        ...mapGetters(['getFieldLabel', 'isFieldVisible', 'isFieldRequired', 'getFieldErrors', 'getFieldMaxLength']),
        ...mapState([
            'addressLine1',
            'addressLine2',
            'neighborhood',
            'sublocality2',
            'sublocality',
            'city',
            'arealevel2',
            'state',
            'country',
            'postalCode',
        ]),
    },
    methods: {
        ...mapMutations(['setAddressField']),
        focusFirstAddressInput() {
            const firstRefComponents = this.$refs.inputTextAddressComponents;
            Vue.nextTick(() => {
                const firstInput = (firstRefComponents as Vue[])[0].$refs?.neighborhood as HTMLInputElement;
                if (firstInput) {
                    firstInput.focus({ preventScroll: true });
                }
            });
        },
    },
});
